import React, {useCallback, useEffect, useState} from 'react';
import {Field, Formik} from "formik";
import FieldCustom from "../Field/FieldCustom";
import loginForm from "../Login/LoginForm";
import AxiosConfig from "../../services/AxiosConfig";
import styles from './../Search/Search.module.css';
import {registerUserToSeanceByCoachAPI} from "../../services/SeanceService";
import {useModal} from "../../contexts/ModalContext";
import {searchCoachs, searchEntreprises, searchReferents, searchUsers} from "../../services/SearchService";

const SearchEntreprise = ({ onSubmit= null, selectedEntreprise = { nom: "", id: "" }, placeholder =  "Rechercher nom, adresse, ville, description ..."}) => {
    const [suggestions, setSuggestions] = useState([]);

    const { showModal } = useModal();

    const handleSuccess = useCallback((message = "Succès") => {
        showModal('success', { children: message, timeout: 3000 });
    }, [showModal]);

    const handleError = useCallback((message = "Une erreur est survenue") => {
        showModal('error', { children: message, timeout: 3000 });
    }, [showModal]);

    const fetchSuggestions = async (value) => {
        if (!value) {
            setSuggestions([]);
            return;
        }
        const response = await searchEntreprises(value);
        setSuggestions(response);
    };

    const handleInputChange = async (e, setFieldValue) => {
        const value = e.target.value;
        setFieldValue('query', value);
        await fetchSuggestions(value);
    };

    const handleSuggestionClick = (suggestion, setFieldValue) => {
        setFieldValue('query', suggestion.nom);
        setFieldValue('entrepriseId', suggestion.id);
        setSuggestions([]);

        // Appel direct avec les vraies valeurs, sans attendre Formik
        if (onSubmit) {
            onSubmit({ query: suggestion.nom, entrepriseId: suggestion.id });
        }
    };

    const handleKeyDown = (e, setFieldValue) => {  // plus besoin de handleSubmit
        if (e.key === 'Enter' && suggestions.length > 0) {
            e.preventDefault();
            handleSuggestionClick(suggestions[0], setFieldValue);
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "row"}}>
            <Formik
                initialValues={{
                    query: selectedEntreprise.nom || '',
                    entrepriseId: selectedEntreprise.id || '',
            }}
                onSubmit={async (values, {setSubmitting}) => {
                    if (onSubmit) {
                        onSubmit(values);
                    } else {
                        console.warn('No onSubmit function provided');
                    }
                    setSubmitting(false);
                }}
            >
                {({ handleSubmit, isSubmitting, setFieldValue }) => (
                    <form onSubmit={handleSubmit} className={styles.searchForm} autoComplete="off">
                        <FieldCustom
                            type={"text"}
                            placeholder={placeholder}
                            id={"query"}
                            name={"query"}
                            label={""}
                            onChange={(e) => handleInputChange(e, setFieldValue)}
                            onKeyDown={(e) => handleKeyDown(e, setFieldValue)}
                        />
                        <Field type={"hidden"} name={"entrepriseId"} id={"entrepriseId"} />

                        <div className={styles.listeDeroulanteContainer}>
                            {suggestions.length > 0 ? (
                                <ul className="suggestions">
                                    {suggestions.map(suggestion => (
                                        <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion, setFieldValue)}>
                                            {suggestion.nom}
                                        </li>
                                    ))}
                                </ul>
                            ) : null }
                        </div>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default SearchEntreprise;
